import React from 'react';
import { Link } from 'react-router-dom';
import { productPages } from '../data/products';
type SmartLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href?: string;
};

/**
 * Routes to built pages inside the app; links to pages that don't exist yet fall back to "#".
 */
export function SmartLink({
  href = '#',
  children,
  ...rest
}: SmartLinkProps) {
  if (isBuiltRoute(href)) {
    return <Link to={href} {...rest} data-id="element-1484" data-mp="1edulrft47ko3">
        {children}
      </Link>;
  }
  return <a href={href.startsWith('/') ? '#' : href} {...rest} data-id="element-1485" data-mp="1ifpmoj74vw1c">
      {children}
    </a>;
}
const staticRoutes = new Set(['/', '/pricing', '/demo', '/get-started', '/contact', '/business-finance/apply', '/whats-new', '/thanks', '/demo/thanks', '/about', '/security', '/blog', '/guides']);
function isBuiltRoute(href: string): boolean {
  const path = href.split('?')[0];
  if (staticRoutes.has(path)) return true;
  if (/^\/legal\/[\w-]+$/.test(path)) return true;
  if (/^\/solutions\/[\w-]+$/.test(path)) return true;
  if (/^\/customers(\/[\w-]+)?$/.test(path)) return true;
  if (/^\/blog\/[\w-]+$/.test(path)) return true;
  if (/^\/careers(\/[\w-]+)?$/.test(path)) return true;
  const match = path.match(/^\/products\/([\w-]+)$/);
  return Boolean(match && productPages[match[1]]);
}